import React from 'react'
import { ImCheckmark2 } from 'react-icons/im'

export const ClinicNotification = () => {
    return (
        <div className='bg-white rounded-lg h-full my-10 px-16 pt-16 flex flex-col items-center w-full shadow-lg'>
            <div className='w-fit flex flex-col gap-2 justify-center items-center'>
                <div className='rounded-full border-dashed border-blue-500 border-2 p-7 w-fit'>
                    <div className='rounded-full bg-[#daeeff] p-4'>
                        <ImCheckmark2 className='text-green-500 text-5xl' />
                    </div>
                </div>
                <h2 className='font-bold text-3xl'>C4C Name</h2>
            </div>
            <p className='mt-36 text-xl font-bold'>
                Clinic Complaints Appear Here .
                <br />
                With Serial Number.
            </p>
        </div>
    )
}
